import styles from './Message.module.css';
import defaultImage from '../../assets/images/hum.png';
import { hideNumber } from '../../helpers/titreHelper';

const Message = ({ message, currentState, winId }) => {
  const errorHandler = (e) => {
    e.target.src = defaultImage;
  };

  return (
    <div className={styles['wrapper']}>
      {message && (
        <div className={`${styles['blockMsg']}`}>
          <div className={styles.avatarBlock}>
            <div
              className={styles.avatarBg}
              style={{
                background: `url(${defaultImage}) center/cover no-repeat`,
              }}
            />

            <img
              className={styles.avatar}
              src={message.image || defaultImage}
              alt=""
              onError={errorHandler}
            />
          </div>

          <div
            className={`${styles['nameAuthor']} ${
              winId === message.id && currentState === 'S4'
                ? styles['winnerBg']
                : ''
            }`}
          >
            {message?.author
              ? message?.author
                  ?.trim()
                  .split(' ')
                  .slice(0, 2)
                  .map((el, i) => (i === 1 ? `${el[0]}.` : el))
                  .join(' ')
              : hideNumber(message?.senderNumber)}
          </div>
        </div>
      )}
    </div>
  );
};

export default Message;
